import React, { useEffect, useState, useRef } from 'react';
import Compressor from "compressorjs";
import { uploadImageWithProgress } from "../../../config/firebaseConfig";
import { useAuth } from "../../../context/AuthContext.js";

const Jawaban = ({ onChange, clean, value, jenised }) => {
  const { user } = useAuth();

  const [jenis, setJenis] = useState("");
  const [jawaban, setJawaban] = useState([]);
  const [valuest, setValuest] = useState({});
  /* ===============================
     UPDATE PARENT
  =============================== */

  const triggerChange = (newJawaban = jawaban, newJenis = jenis) => {
    if (onChange) {
      onChange({
        jenis: newJenis,
        jawaban: newJawaban
      });
    }
  };

  useEffect(() => {
    setJawaban([])
    setJenis()


  }, [clean]);
  useEffect(() => {


    if (value) {
      setValuest(value)
      setJenis(jenised || "");
      setJawaban(value || []);
      triggerChange(value, jenised)
    }
  }, [value, jenised]);

  /* ===============================
     UPLOAD IMAGE
  =============================== */

  const handleUploadImage = (editorId, idjwb, field) => {
    if (!user?.uid) return;

    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";

    input.onchange = (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const processFile = (image) => {
        uploadImageWithProgress(
          image,
          user.uid,
          "imgsoaljawaban",
          null,
          (url) => {
            const editor = document.getElementById(editorId);
            if (editor) {
              editor.innerHTML += `<br/><img src="${url}" style="max-width:100%;margin:10px 0;" />`;
              editor.dispatchEvent(new Event("input"));
              const updated = jawaban.map(item =>
                item.id_jwb === idjwb
                  ? { ...item, [field]: editor.innerHTML }
                  : item
              );

              setJawaban(updated);
              triggerChange(updated);

            }
          },
          console.error
        );
      };

      if (file.size > 5 * 1024 * 1024) {
        new Compressor(file, {
          quality: 0.6,
          maxWidth: 1920,
          maxHeight: 1080,
          success: (compressed) => processFile(compressed),
        });
      } else {
        processFile(file);
      }
    };

    input.click();
  };

  /* ===============================
     JENIS CHANGE
  =============================== */

  const handleJenisChange = (type) => {
    setJenis(type);

    if (jawaban.length === 0) {
      let init;

      if (type === "cj") {
        init = [{ id_jwb: 1, text: "", text2: "" }];
      } else {
        init = [{ id_jwb: 1, kunci: 0, text: "" }];
      }

      setJawaban(init);
      setValuest(init)
      triggerChange(init, type);
    } else {
      triggerChange(jawaban, type);
    }
  };

  /* ===============================
     ADD JAWABAN
  =============================== */

  const handleAddJawaban = () => {
    let newData;

    if (jenis === "cj") {
      newData = [
        ...jawaban,
        { id_jwb: jawaban.length + 1, kiri: "", kanan: "" }
      ];
    } else {
      newData = [
        ...jawaban,
        { id_jwb: jawaban.length + 1, kunci: 0, text: "" }
      ];
    }
    setValuest(newData)
    setJawaban(newData);
    triggerChange(newData);
  };

  /* ===============================
     UPDATE TEXT
  =============================== */

  const handleEditorChange = (id, field, value) => {

    const cleanHTML = sanitizeHTML(value);

    const updated = jawaban.map(item =>
      item.id_jwb === id
        ? { ...item, [field]: cleanHTML }
        : item
    );

    setJawaban(updated);
    triggerChange(updated);
  };
  const handleRadioChange = (id) => {
    const updated = jawaban.map(item => ({
      ...item,
      kunci: item.id_jwb === id ? 1 : 0
    }));

    setJawaban(updated);
    triggerChange(updated);
  };

  const handleCheckboxChange = (id) => {
    const updated = jawaban.map(item =>
      item.id_jwb === id
        ? { ...item, kunci: item.kunci ? 0 : 1 }
        : item
    );

    setJawaban(updated);
    triggerChange(updated);
  };

  const handleBenarSalah = (id, value) => {
    const updated = jawaban.map(item =>
      item.id_jwb === id
        ? { ...item, kunci: value }
        : item
    );

    setJawaban(updated);
    triggerChange(updated);
  };

  /* ===============================
     UI
  =============================== */
  const jenisLabel = {
    objectif: "Objektif",
    ganda: "Ceklis",
    essay: "Esai",
    cj: "Cocokkan",
    bs: "Benar Salah"
  };

  const handleHapusJawaban = (id) => {
    if (jawaban.length === 1) return;

    const updated = jawaban
      .filter(item => item.id_jwb !== id)
      .map((item, i) => ({ ...item, id_jwb: i + 1 }));

    setJawaban(updated);
    setValuest(updated);
    triggerChange(updated);
  };

  const sanitizeHTML = (html) => {
    const allowedTags = ["B", "I", "U", "UL", "LI", "BR", "IMG"];

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const cleanNode = (node) => {
      [...node.children].forEach((child) => {
        if (!allowedTags.includes(child.tagName)) {
          // ganti tag dengan isi textnya
          child.replaceWith(...child.childNodes);
        } else {
          cleanNode(child);
        }
      });
    };

    cleanNode(doc.body);

    return doc.body.innerHTML;
  };
  return (
    <div className="col-md-12">

      {/* DROPDOWN */}
      <div className="btn-group dropstart mb-4">
        <button className="btn btn-secondary">
          {jenisLabel[jenis] ?? "Pilih Jenis Jawaban"}
        </button>
        <button className="btn btn-secondary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" />
        <div className="dropdown-menu">
          <button onClick={() => handleJenisChange("objectif")} className="dropdown-item">Objektif</button>
          <button onClick={() => handleJenisChange("ganda")} className="dropdown-item">Ceklis</button>
          <button onClick={() => handleJenisChange("essay")} className="dropdown-item">Essay</button>
          <button onClick={() => handleJenisChange("cj")} className="dropdown-item">Cocokkan</button>
          <button onClick={() => handleJenisChange("bs")} className="dropdown-item">Benar / Salah</button>
        </div>
      </div>

      {/* ================= OBJECTIF ================= */}
      {jenis === "objectif" && jawaban.map((item, index) => (
        <div key={item.id_jwb} className="input-group mb-3">
          <span className="input-group-text">
            <input type="radio"
              checked={item.kunci === 1}
              onChange={() => handleRadioChange(item.id_jwb)}
            />
          </span>

          <span className="input-group-text">
            <button
              className="btn btn-sm btn-dark"
              onClick={() => handleUploadImage(`obj_${item.id_jwb}`, item.id_jwb, 'text')}
            >📷</button>
          </span>

          <div
            id={`obj_${item.id_jwb}`}
            className="form-control"
            contentEditable
            dangerouslySetInnerHTML={{ __html: valuest[index].text }}
            onInput={(e) =>
              handleEditorChange(item.id_jwb, "text", e.currentTarget.innerHTML)
            }
            style={{ minHeight: 60 }}
          />
          <span className="input-group-text">
            <button className="btn btn-sm btn-danger" disabled={jawaban.length === 1} onClick={() => handleHapusJawaban(item.id_jwb)}>🗑️</button>
          </span>
        </div>
      ))}

      {/* ================= GANDA ================= */}
      {jenis === "ganda" && jawaban.map((item, index) => (
        <div key={item.id_jwb} className="input-group mb-3">
          <span className="input-group-text">
            <input type="checkbox"
              checked={item.kunci === 1}
              onChange={() => handleCheckboxChange(item.id_jwb)}
            />
          </span>

          <span className="input-group-text">
            <button
              className="btn btn-sm btn-dark"
              onClick={() => handleUploadImage(`ganda_${item.id_jwb}`, item.id_jwb, 'text')}
            >📷</button>
          </span>

          <div
            id={`ganda_${item.id_jwb}`}
            className="form-control"
            contentEditable
            dangerouslySetInnerHTML={{ __html: valuest[index].text }}
            onInput={(e) =>
              handleEditorChange(item.id_jwb, "text", e.currentTarget.innerHTML)
            }
            style={{ minHeight: 60 }}
          />
          <span className="input-group-text">
            <button className="btn btn-sm btn-danger" disabled={jawaban.length === 1} onClick={() => handleHapusJawaban(item.id_jwb)}>🗑️</button>
          </span>
        </div>
      ))}

      {/* ================= MATCHING ================= */}
      {jenis === "cj" && jawaban.map((item, index) => (
        <div key={item.id_jwb} className="row mb-3">

          <div className="col-md-6">
            <div className="input-group">
              <span className="input-group-text">
                <button
                  className="btn btn-sm btn-dark"
                  onClick={() => handleUploadImage(`left_${item.id_jwb}`, item.id_jwb, 'text')}
                >📷</button>
              </span>
              <div
                id={`left_${item.id_jwb}`}
                className="form-control"
                contentEditable
                dangerouslySetInnerHTML={{ __html: valuest[index].text }}
                onInput={(e) =>
                  handleEditorChange(item.id_jwb, "text", e.currentTarget.innerHTML)
                }
              />
            </div>
          </div>


          <div className="col-md-6">
            <div className="input-group">
              <span className="input-group-text">
                <button
                  className="btn btn-sm btn-dark"
                  onClick={() => handleUploadImage(`right_${item.id_jwb}`, item.id_jwb, 'text2')}
                >📷</button>
              </span>
              <div
                id={`right_${item.id_jwb}`}
                className="form-control"
                contentEditable
                dangerouslySetInnerHTML={{ __html: valuest[index].text2 }}
                onInput={(e) =>
                  handleEditorChange(item.id_jwb, "text", e.currentTarget.innerHTML)
                }
              />
              <div className="col-md-12 text-end mt-2">
                <button className="btn btn-sm btn-danger" disabled={jawaban.length === 1} onClick={() => handleHapusJawaban(item.id_jwb)}>🗑️ Hapus</button>
              </div>
            </div>
          </div>

        </div>
      ))}

      {/* ================= BENAR SALAH ================= */}
      {jenis === "bs" && jawaban.map((item, index) => (
        <div key={item.id_jwb} className="row mb-3 align-items-center">
          <div className="col-md-2">
            <input type="radio"
              name={`bs_${item.id_jwb}`}
              checked={item.kunci === 1}
              onChange={() => handleBenarSalah(item.id_jwb, 1)}
            /> Benar
          </div>
          <div className="col-md-2">
            <input type="radio"
              name={`bs_${item.id_jwb}`}
              checked={item.kunci === 0}
              onChange={() => handleBenarSalah(item.id_jwb, 0)}
            /> Salah
          </div>
          <div className="col-md-8">
            <div className="input-group">
              <span className="input-group-text">
                <button
                  className="btn btn-sm btn-dark"
                  onClick={() => handleUploadImage(`bs_${item.id_jwb}`, item.id_jwb, 'text')}
                >📷</button>
              </span>
              <div
                id={`bs_${item.id_jwb}`}
                className="form-control"
                contentEditable
                dangerouslySetInnerHTML={{ __html: valuest[index].text }}
                onInput={(e) =>
                  handleEditorChange(item.id_jwb, "text", e.currentTarget.innerHTML)
                }
                style={{ minHeight: 60 }}
              />
              <div className="col-md-2 text-end">
                <button className="btn btn-sm btn-danger" disabled={jawaban.length === 1} onClick={() => handleHapusJawaban(item.id_jwb)}>🗑️</button>
              </div>
            </div>
          </div>
        </div>
      ))}

      {jenis && (
        <button className="btn btn-outline-primary" onClick={handleAddJawaban}>
          Tambah Jawaban
        </button>
      )}

    </div>
  );
};

export default Jawaban;
